import { render } from "./CloseLogo.vue?vue&type=template&id=79239663"
const script = {}

import exportComponent from "/home/forge/usta.ge/vue-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__